/**
 * Digital Ocean serverless functions base URL.
 * Used for dashboard, billing, pods, users, and related endpoints.
 */
export const DO_FUNCTIONS_BASE =
  "https://server2.engage-ai.co";

export const WARM_DASHBOARD_API_BASE = "https://server3.engage-ai.co/v1/web/v1";